interface ISvgProps {
  className?: string;
}

export const Star = ({ className }: ISvgProps) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M25.0006 35.9894L16.3548 41.1978C15.9728 41.4408 15.5735 41.545 15.1569 41.5103C14.7402 41.4755 14.3756 41.3366 14.0631 41.0936C13.7506 40.8505 13.5075 40.5467 13.3339 40.1821C13.1603 39.8175 13.1256 39.4096 13.2298 38.9582L15.5214 29.1144L7.86518 22.4998C7.51796 22.1873 7.30095 21.8314 7.21414 21.4321C7.12734 21.0328 7.15338 20.6422 7.29227 20.2603C7.43116 19.8783 7.63949 19.5658 7.91727 19.3228C8.19505 19.0797 8.57699 18.9234 9.0631 18.854L19.1673 17.9686L23.0735 8.69775C23.2471 8.28109 23.5162 7.96859 23.8808 7.76025C24.2454 7.55192 24.6187 7.44775 25.0006 7.44775C25.3825 7.44775 25.7558 7.55192 26.1204 7.76025C26.485 7.96859 26.7541 8.28109 26.9277 8.69775L30.8339 17.9686L40.9381 18.854C41.4242 18.9234 41.8062 19.0797 42.0839 19.3228C42.3617 19.5658 42.57 19.8783 42.7089 20.2603C42.8478 20.6422 42.8739 21.0328 42.7871 21.4321C42.7003 21.8314 42.4832 22.1873 42.136 22.4998L34.4798 29.1144L36.7714 38.9582C36.8756 39.4096 36.8409 39.8175 36.6673 40.1821C36.4937 40.5467 36.2506 40.8505 35.9381 41.0936C35.6256 41.3366 35.261 41.4755 34.8444 41.5103C34.4277 41.545 34.0284 41.4408 33.6464 41.1978L25.0006 35.9894Z"
      fill="#EED202"
    />
  </svg>
);

export const Star2 = ({ className }: ISvgProps) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.5001 17.9948L8.17714 20.599C7.98617 20.7205 7.78651 20.7726 7.57818 20.7552C7.36985 20.7379 7.18756 20.6684 7.03131 20.5469C6.87506 20.4254 6.75353 20.2735 6.66672 20.0912C6.57992 19.9089 6.56256 19.7049 6.61464 19.4792L7.76047 14.5573L3.93235 11.25C3.75874 11.0938 3.65023 10.9158 3.60683 10.7162C3.56342 10.5165 3.57645 10.3212 3.64589 10.1302C3.71533 9.93928 3.8195 9.78303 3.95839 9.6615C4.09728 9.53997 4.28825 9.46185 4.53131 9.42712L9.58339 8.98442L11.5365 4.349C11.6233 4.14067 11.7579 3.98442 11.9402 3.88025C12.1225 3.77608 12.3091 3.724 12.5001 3.724C12.691 3.724 12.8777 3.77608 13.06 3.88025C13.2422 3.98442 13.3768 4.14067 13.4636 4.349L15.4167 8.98442L20.4688 9.42712C20.7119 9.46185 20.9028 9.53997 21.0417 9.6615C21.1806 9.78303 21.2848 9.93928 21.3542 10.1302C21.4237 10.3212 21.4367 10.5165 21.3933 10.7162C21.3499 10.9158 21.2414 11.0938 21.0678 11.25L17.2396 14.5573L18.3855 19.4792C18.4376 19.7049 18.4202 19.9089 18.3334 20.0912C18.2466 20.2735 18.1251 20.4254 17.9688 20.5469C17.8126 20.6684 17.6303 20.7379 17.4219 20.7552C17.2136 20.7726 17.0139 20.7205 16.823 20.599L12.5001 17.9948Z"
      fill="#121212"
    />
  </svg>
);